import React, { useState } from 'react'
import { FaPlayCircle, FaTimes } from 'react-icons/fa'
import { Box, Icon, Button, SimpleModal, Alert, Loading, Heading, Text, ConfirmButton } from '@/components/lib'

export default function Video ({ url, withPreview, thumbUrl, isProcessing, hasError, onRemove }) {
  const [openFull, setOpenFull] = useState(false)

  if (!url) return null
  const isMp4 = url?.toLowerCase()?.indexOf('.mp4') > -1
  return (
    <>
      {withPreview
        ? (
          <Box>
            <Box
              h='100px' w='100px' bg='bg.muted' rounded='md' cursor='pointer' display='flex' justifyContent='center' alignItems='center'
              style={{
                backgroundImage: thumbUrl ? `url(${thumbUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
              }}
              transition='0.25s' _hover={{ shadow: 'lg' }}
              onClick={() => setOpenFull(true)}
            >
              <Icon as={FaPlayCircle} color='primary.fg' w='50px' h='50px' />
            </Box>

            <SimpleModal
              modalProps={{ size: '5xl' }} isOpen={openFull} onClose={() => setOpenFull(false)}
              body={
                <Box>
                  {!isMp4 && isProcessing && <VideoLoading url={url} />}
                  {isMp4 &&
                    <video autoPlay controls style={{ maxwidth: '100%', maxHeight: '500px' }}>
                      <source src={url} />
                    </video>}
                </Box>
}
            />
          </Box>)
        : (
          <Box display='flex' justifyContent='center' mt={5}>
            <Box p={3} bg='bg.surface' minWidth='400px' maxWidth='80%' rounded='md' shadow='md'>
              {onRemove &&
                <Box mb={3} display='flex' justifyContent='end'>
                  <ConfirmButton
                    header='Really remove this video?'
                    trigger={<Button variant='ghost'><Icon as={FaTimes} mr={2} /> Remove</Button>}
                    onConfirm={onRemove}
                  />
                </Box>}
              {!isMp4 && !hasError && isProcessing && <VideoLoading url={url} />}
              {hasError &&
                <Box mb={3}>
                  <Alert size='xs' variant='left-accent' status='warning'>
                    <Box>
                      <Text>There was an error processing this video. Please try again.</Text>
                      <Button mt={3} size='sm' colorPalette='blue' as='a' target='_blank' rel='noopener noreferrer' href={url}>Download unprocessed video</Button>
                    </Box>
                  </Alert>
                </Box>}
              {isMp4 &&
                <video controls style={{ width: '100%', maxHeight: '500px' }}>
                  <source src={url} />
                </video>}
            </Box>
          </Box>)}
    </>
  )
}

function VideoLoading ({ url }) {
  return (
    <Alert size='xs' variant='left-accent'>
      <Loading />
      <Box>
        <Heading size='sm'>Trialflare is processing this video in the background</Heading>
        <Text>It is safe to continue and save or submit your changes. Please come back later to view the video.</Text>
        <Button mt={5} size='sm' colorPalette='blue' variant='outline' as='a' target='_blank' rel='noopener noreferrer' href={url}>Download non-processed version</Button>
      </Box>
    </Alert>
  )
}
